import { render, staticRenderFns } from "./accidentReports.vue?vue&type=template&id=3b72048b&scoped=true"
import script from "./accidentReports.vue?vue&type=script&lang=js"
export * from "./accidentReports.vue?vue&type=script&lang=js"
import style0 from "./accidentReports.vue?vue&type=style&index=0&id=3b72048b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b72048b",
  null
  
)

export default component.exports